<div class="fa-page">

  <!-- ============================================================
       1. HERO
       ============================================================ -->
  <section class="fa-hero">
    <div class="fa-hero-blob fa-hero-blob--1"></div>
    <div class="fa-hero-blob fa-hero-blob--2"></div>
    <div class="fa-container">
      <div class="fa-hero-inner">

        <div class="fa-hero-left">
          <div class="fa-hero-badge">
            <span class="fa-badge-pulse"></span>
            100% Free — No Payment Required
          </div>
          <h1 class="fa-hero-title">
            Free 11+ Assessment<br>
            <em>Know Where Your Child Stands</em>
          </h1>
          <p class="fa-hero-sub">A fully online diagnostic test with a detailed RAR report and a personalised Parent–Teacher Meeting — completely free of charge.</p>
          <div class="fa-hero-actions">
            <button class="fa-btn-primary" (click)="scrollToTests()">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Book Free Assessment
            </button>
            <button class="fa-btn-ghost" (click)="scrollToHowItWorks()">
              How It Works
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
            </button>
          </div>
          <div class="fa-hero-stats">
            <div class="fa-hstat"><strong>Free</strong><span>No Cost Ever</span></div>
            <div class="fa-hstat-div"></div>
            <div class="fa-hstat"><strong>Online</strong><span>From Home</span></div>
            <div class="fa-hstat-div"></div>
            <div class="fa-hstat"><strong>RAR</strong><span>Detailed Report</span></div>
            <div class="fa-hstat-div"></div>
            <div class="fa-hstat"><strong>PTM</strong><span>1-to-1 Guidance</span></div>
          </div>
        </div>

        <!-- Right: What you get -->
        <div class="fa-hero-right">
          <div class="fa-hero-card">
            <div class="fa-hero-card-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
              What's Included — Free
            </div>
            <div class="fa-incl-list">
              <div class="fa-incl-item">
                <div class="fa-incl-ico fa-incl-ico--green">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <div>
                  <div class="fa-incl-label">Full Online Diagnostic Test</div>
                  <div class="fa-incl-sub">Timed, exam-style paper taken from home</div>
                </div>
              </div>
              <div class="fa-incl-item">
                <div class="fa-incl-ico fa-incl-ico--blue">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <div>
                  <div class="fa-incl-label">Detailed RAR Report</div>
                  <div class="fa-incl-sub">Score, rank &amp; topic-by-topic breakdown</div>
                </div>
              </div>
              <div class="fa-incl-item">
                <div class="fa-incl-ico fa-incl-ico--gold">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <div>
                  <div class="fa-incl-label">Parent–Teacher Meeting (PTM)</div>
                  <div class="fa-incl-sub">1-to-1 session discussing your child's results</div>
                </div>
              </div>
              <div class="fa-incl-item">
                <div class="fa-incl-ico fa-incl-ico--purple">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <div>
                  <div class="fa-incl-label">Personalised Improvement Plan</div>
                  <div class="fa-incl-sub">Clear next steps tailored to your child</div>
                </div>
              </div>
            </div>
            <button class="fa-hero-card-cta" (click)="scrollToTests()">
              Claim Your Free Spot →
            </button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       2. TRUST STRIP
       ============================================================ -->
  <div class="fa-trust">
    <div class="fa-container">
      <div class="fa-trust-inner">
        <div class="fa-trust-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          No credit card required
        </div>
        <div class="fa-trust-div"></div>
        <div class="fa-trust-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          Takes 60 seconds to book
        </div>
        <div class="fa-trust-div"></div>
        <div class="fa-trust-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          10,000+ families trust Sehyog
        </div>
        <div class="fa-trust-div"></div>
        <div class="fa-trust-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
          100% online — from home
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================
       3. HOW IT WORKS
       ============================================================ -->
  <section class="fa-how" id="how-it-works">
    <div class="fa-container">
      <div class="fa-section-hd">
        <p class="fa-eyebrow">Simple Process</p>
        <h2 class="fa-section-title">How It <span>Works</span></h2>
        <p class="fa-section-sub">From booking to your child's personalised improvement plan — all free, all online.</p>
      </div>

      <div class="fa-steps">

        <div class="fa-step">
          <div class="fa-step-num">01</div>
          <div class="fa-step-ico">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </div>
          <div class="fa-step-content">
            <h3 class="fa-step-title">Book Your Free Slot</h3>
            <p class="fa-step-text">Choose a date below and register in under 60 seconds. No payment, no commitment.</p>
          </div>
          <div class="fa-step-connector"></div>
        </div>

        <div class="fa-step">
          <div class="fa-step-num">02</div>
          <div class="fa-step-ico">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </div>
          <div class="fa-step-content">
            <h3 class="fa-step-title">Take the Online Test</h3>
            <p class="fa-step-text">Your child completes a full diagnostic 11+ paper online at home under guided timed conditions.</p>
          </div>
          <div class="fa-step-connector"></div>
        </div>

        <div class="fa-step">
          <div class="fa-step-num">03</div>
          <div class="fa-step-ico">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/></svg>
          </div>
          <div class="fa-step-content">
            <h3 class="fa-step-title">Receive Your RAR Report</h3>
            <p class="fa-step-text">Get a detailed Result Analysis Report covering score, percentile, strengths and weak topics — within 48 hours.</p>
          </div>
          <div class="fa-step-connector"></div>
        </div>

        <div class="fa-step fa-step--last">
          <div class="fa-step-num fa-step-num--gold">04</div>
          <div class="fa-step-ico fa-step-ico--gold">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          </div>
          <div class="fa-step-content">
            <h3 class="fa-step-title">Parent–Teacher Meeting (PTM)</h3>
            <p class="fa-step-text">A 1-to-1 meeting with an expert tutor to discuss results, answer your questions and build a clear improvement plan.</p>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       4. WHAT YOU GET — RAR + PTM deep-dive
       ============================================================ -->
  <section class="fa-details">
    <div class="fa-container">
      <div class="fa-section-hd">
        <p class="fa-eyebrow">Included Free</p>
        <h2 class="fa-section-title">What You Get After <span>the Test</span></h2>
      </div>

      <div class="fa-details-grid">

        <!-- RAR Report -->
        <div class="fa-detail-card fa-detail-card--rar">
          <div class="fa-detail-card-header">
            <div class="fa-detail-icon">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/></svg>
            </div>
            <div>
              <div class="fa-detail-tag">Result Analysis Report</div>
              <h3 class="fa-detail-title">RAR Report</h3>
            </div>
          </div>
          <p class="fa-detail-intro">A comprehensive breakdown of your child's performance delivered within 48 hours of the test.</p>
          <ul class="fa-detail-list">
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Overall score &amp; standardised percentile</strong> — see exactly where your child ranks
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Topic-by-topic analysis</strong> — Maths, English, Verbal &amp; Non-Verbal Reasoning
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Strengths &amp; weak areas</strong> — clearly highlighted for targeted revision
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Cohort benchmarking</strong> — compared against all students who sat the same paper
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Gap-to-target score</strong> — how far from grammar school entry standard
            </li>
          </ul>
          <div class="fa-detail-footer">
            <div class="fa-detail-badge">Delivered within 48 hrs</div>
            <div class="fa-detail-badge fa-detail-badge--free">Free</div>
          </div>
        </div>

        <!-- PTM -->
        <div class="fa-detail-card fa-detail-card--ptm">
          <div class="fa-detail-card-header">
            <div class="fa-detail-icon fa-detail-icon--gold">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <div>
              <div class="fa-detail-tag fa-detail-tag--gold">Parent–Teacher Meeting</div>
              <h3 class="fa-detail-title">PTM Session</h3>
            </div>
          </div>
          <p class="fa-detail-intro">A dedicated 1-to-1 online meeting with an experienced 11+ tutor to walk through your child's results together.</p>
          <ul class="fa-detail-list">
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Live walkthrough of the RAR</strong> — tutor explains every section clearly
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Priority improvement areas</strong> — what to focus on first for maximum gain
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Exam strategy guidance</strong> — time management, question techniques and exam-day tips
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Recommended preparation pathway</strong> — Topic Tests → Sprints → Full Mocks
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Open Q&amp;A</strong> — ask anything about 11+, school selection or CAF forms
            </li>
          </ul>
          <div class="fa-detail-footer">
            <div class="fa-detail-badge">Online · 30–45 mins</div>
            <div class="fa-detail-badge fa-detail-badge--free">Free</div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       5. WHY FREE — reassurance section
       ============================================================ -->
  <section class="fa-why">
    <div class="fa-container">
      <div class="fa-why-inner">
        <div class="fa-why-left">
          <p class="fa-eyebrow">Our Promise</p>
          <h2 class="fa-section-title">Why Is This <span>Free?</span></h2>
          <p class="fa-why-text">At Sehyog, we believe every child deserves the chance to know where they stand before the real 11+ journey begins. The free assessment removes the financial barrier so parents can make informed decisions — with no obligation and no pressure.</p>
          <p class="fa-why-text">There is nothing to pay now or later. The test, the RAR report and the PTM are completely free.</p>
          <div class="fa-why-promise">
            <div class="fa-promise-item">
              <div class="fa-promise-ico">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              </div>
              <span>No hidden fees, ever</span>
            </div>
            <div class="fa-promise-item">
              <div class="fa-promise-ico">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              <span>No obligation to purchase</span>
            </div>
            <div class="fa-promise-item">
              <div class="fa-promise-ico">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              </div>
              <span>Results within 48 hours</span>
            </div>
            <div class="fa-promise-item">
              <div class="fa-promise-ico">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              </div>
              <span>Fully online — no travel</span>
            </div>
          </div>
        </div>
        <div class="fa-why-right">
          <div class="fa-why-card">
            <div class="fa-why-card-top">
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>
              <div>
                <div class="fa-why-card-label">Trusted by</div>
                <div class="fa-why-card-num">10,000+</div>
                <div class="fa-why-card-sub">families across England</div>
              </div>
            </div>
            <div class="fa-why-divider"></div>
            <blockquote class="fa-why-quote">
              "The free assessment opened our eyes to exactly where our daughter needed help. The RAR was incredibly detailed and the PTM gave us a clear plan. We had no idea Sehyog offered this for free."
            </blockquote>
            <div class="fa-why-quote-name">Priya S., parent from Ilford</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       6. FREE ASSESSMENTS — session list
       ============================================================ -->
  <div class="fa-list-heading" id="free-tests-section">
    <div class="fa-container">
      <p class="fa-eyebrow" style="justify-content:center">Step 1 — Pick Your Session</p>
      <h2 class="fa-section-title" style="text-align:center">Available Free <span>Assessment Dates</span></h2>
      <p style="text-align:center;font-size:15px;color:var(--fa-tl);margin-top:8px">All sessions are online and completely free. Click the green <strong style="color:var(--fa-free)">Book Free →</strong> button to register.</p>
    </div>
  </div>

  <!-- STICKY FILTER BAR -->
  <div class="fa-filterbar">
    <div class="fa-filterbar-main">
      <div class="fa-container">
        <div class="fa-filters-row">

          <div class="fa-fg fa-fg--search">
            <label class="fa-flabel">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
              Search
            </label>
            <input type="text" class="fa-finput"
                   placeholder="Name, date, exam board..."
                   [(ngModel)]="filters.search" (input)="applyFilters()" />
          </div>

          <div class="fa-fg">
            <label class="fa-flabel">Exam Board</label>
            <select class="fa-fselect" [(ngModel)]="filters.pattern" (change)="applyFilters()">
              <option [ngValue]="null">All Boards</option>
              <option *ngFor="let p of patternTypes" [ngValue]="p.type_id">{{ p.type }}</option>
            </select>
          </div>

          <button class="fa-freset" (click)="resetFilters()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Reset
          </button>

        </div>
      </div>
    </div>

    <div class="fa-filterbar-pills" *ngIf="filters.pattern || filters.search">
      <div class="fa-container">
        <div class="fa-pills-row">
          <span class="fa-pills-label">Active filters:</span>
          <span class="fa-pill" *ngIf="filters.pattern">
            Board
            <button class="fa-pill-x" (click)="filters.pattern=null;applyFilters()">✕</button>
          </span>
          <span class="fa-pill" *ngIf="filters.search">
            "{{ filters.search }}"
            <button class="fa-pill-x" (click)="filters.search='';applyFilters()">✕</button>
          </span>
          <span class="fa-count">{{ freeTestList?.length || 0 }} session{{ freeTestList?.length !== 1 ? 's' : '' }} found</span>
        </div>
      </div>
    </div>
  </div>

  <!-- SESSION LIST -->
  <section class="fa-sessions">
    <div class="fa-container">

      <div class="fa-sortbar">
        <span class="fa-sortbar-count" *ngIf="freeTestList?.length > 0">
          Showing <strong>{{ freeTestList.length }}</strong> free session{{ freeTestList.length !== 1 ? 's' : '' }}
        </span>
        <div class="fa-sortbar-right">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="3" y2="18"/></svg>
          Sorted by date (earliest first)
        </div>
      </div>

      <ng-container *ngIf="freeTestList && freeTestList.length > 0; else faEmpty">

        <div class="fa-scard" *ngFor="let t of freeTestList">

          <span style="display:none">{{ t.test_name }} {{ t.course }} {{ t.category }} {{ t.type }} {{ t.all_location || t.location }}</span>

          <!-- Date panel -->
          <div class="fa-scard-date" [class.fa-scard-date--range]="isRangeDate(t.test_date)" [class.fa-scard-date--tbd]="!hasDate(t.test_date)">
            <ng-container *ngIf="hasDate(t.test_date); else noDate">
              <span class="fa-scard-from" >From</span>
              <span class="fa-scard-day">{{ getDateDay(t.test_date) }}</span>
              <span class="fa-scard-mon">{{ getDateMon(t.test_date) }}</span>
              <span class="fa-scard-yr">{{ getDateYr(t.test_date) }}</span>
            </ng-container>
            <ng-template #noDate>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="opacity:.55"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span class="fa-scard-tbd">TBC</span>
            </ng-template>
          </div>

          <!-- Info -->
          <div class="fa-scard-info">
            <div class="fa-scard-top">
              <a class="fa-scard-cat" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
                {{ t.test_name }}
              </a>
              <span class="fa-scard-badge-online">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
                Online
              </span>
              <span class="fa-scard-badge-free">Free</span>
            </div>
            <a class="fa-scard-type" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">{{ trimChar(t.type) }}</a>
            <!-- <a class="fa-scard-name" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">{{ t.test_name }}</a> -->
            <div class="fa-scard-includes">
              <span class="fa-scard-incl-tag">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                RAR Report
              </span>
              <span class="fa-scard-incl-tag">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                PTM Session
              </span>
              <span class="fa-scard-incl-tag">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Improvement Plan
              </span>
            </div>
          </div>

          <!-- Free label -->
          <div class="fa-scard-price">
            <span class="fa-price-free">FREE</span>
            <span class="fa-price-lbl">no cost</span>
          </div>

          <!-- Book button -->
          <div class="fa-scard-book">
            <a class="fa-book-btn" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Book Free
            </a>
          </div>

        </div>

      </ng-container>

      <ng-template #faEmpty>
        <div class="fa-empty">
          <div class="fa-empty-ico">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
          </div>
          <h3 class="fa-empty-title">No free sessions match your filters</h3>
          <p class="fa-empty-sub">Try clearing the filters or check back soon for new dates</p>
          <button class="fa-empty-reset" (click)="resetFilters()">Clear Filters</button>
        </div>
      </ng-template>

    </div>
  </section>

  <!-- ============================================================
       7. TESTIMONIALS
       ============================================================ -->
  <section class="fa-testi">
    <div class="fa-container">
      <div class="fa-section-hd fa-section-hd--light">
        <p class="fa-eyebrow fa-eyebrow--light">Parent Feedback</p>
        <h2 class="fa-section-title fa-section-title--light">What <span>Parents</span> Say</h2>
      </div>
      <div class="fa-testi-grid">
        <div class="fa-tcard" *ngFor="let t of testimonials">
          <div class="fa-tcard-quote">"</div>
          <p class="fa-tcard-text">{{ t.text }}</p>
          <div class="fa-tcard-name">{{ t.name }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       8. FAQ
       ============================================================ -->
  <section class="fa-faq">
    <div class="fa-container">
      <div class="fa-section-hd">
        <p class="fa-eyebrow">Any Questions?</p>
        <h2 class="fa-section-title">Frequently <span>Asked</span></h2>
      </div>
      <div class="fa-faq-list">
        <div class="fa-faq-item" *ngFor="let f of faqs; let i = index" [class.fa-faq-item--open]="openFaq === i">
          <button class="fa-faq-q" (click)="toggleFaq(i)">
            {{ f.q }}
            <svg class="fa-faq-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="fa-faq-a">{{ f.a }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       9. CONTACT STRIP
       ============================================================ -->
  <div class="fa-contact">
    <div class="fa-container">
      <div class="fa-contact-inner">
        <p class="fa-contact-title">Still have questions? We're here to help.</p>
        <div class="fa-contact-links">
          <a href="tel:+447464772331" class="fa-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
            +44 7464 772331
          </a>
          <a href="mailto:academy@sehyog.co.uk" class="fa-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            academy@sehyog.co.uk
          </a>
        </div>
      </div>
    </div>
  </div>

</div>